<template>
  <div>
    <validation-observer ref="modalSearch">
      <b-card no-body>
        <div class="m-2">

          <!-- Table Top -->
          <b-row class="pb-0">
            <b-col cols="4">
              <b-form-group label="Nhập số thuê bao Itel">
                <validation-provider #default="{ errors }">
                  <b-form-input v-model="msisdn" :state="errors.length > 0 ? false:null" placeholder="087xxx"/>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Từ ngày">
                <validation-provider #default="{ errors }">
                  <b-form-datepicker
                      v-model="from"
                      :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                      :state="errors.length > 0 ? false:null" close-button locale="vi-VN"
                      reset-button
                      today-button
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Đến ngày">
                <validation-provider #default="{ errors }">
                  <b-form-datepicker
                      v-model="to"
                      :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                      :state="errors.length > 0 ? false:null" close-button locale="vi-VN"
                      reset-button
                      today-button
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col class="text-center" cols="12">
              <b-button variant="primary" @click="loadData">Xem lịch sử gọi, tin nhắn</b-button>
            </b-col>
            <!-- Per Page -->
          </b-row>
        </div>
      </b-card>
    </validation-observer>

    <b-row>
      <b-col lg="12" md="12">
        <b-card v-if="data" body-class="p-0">
          <div class="">
            <table class="table table-sm table-bordered table-striped">
              <thead>
              <tr>
                <th>STT</th>
                <th>Số bị gọi</th>
                <th>Ngày tháng</th>
                <th>Loại</th>
                <th>Thời gian gọi</th>
                <th>Phí</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(i,stt) in data" :key="stt">
                <td>{{ stt + 1 }}</td>
                <td>{{ i.subscriberNumber }}</td>
                <td>{{ i.transactionDateTime }}</td>
                <td>{{ TSCList.find(m => m.id == i.tSC).text }}</td>
                <td>{{ i.duration|number }}</td>
                <td>{{ i.transactionAmount|number }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
    </b-row>


  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';


export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {


  },
  watch: {},
  methods: {
    async loadData() {
      var validate = await this.$refs.modalSearch.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      this.$store.dispatch('crm/fetchCDRDetail', this);
    },
  },
  data() {
    return {
      msisdn: '',
      data: null,
      from: '',
      to: '',
      isLoading: false,
      required,
      TSCList: [
        {id: 0, text: 'Thoại'},
        {id: 4, text: 'SMS'},
        {id: 6, text: 'Data/Dịch vụ GTGT'},
      ]
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
